/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createFeatureSelector, createSelector } from '@ngrx/store'

import { ActionDefinition } from '@flowx/designer/modules/core/dictionary/process.dictionary'
import { ActionHandler } from '@flowx/designer/modules/node-actions/components/action-edit/action-edit.dictionary'
import { AllowedActionTypesForUIActions } from '@flowx/designer/modules/ui-designer/services/templateConfig.entity'
import { selectedNode } from '@flowx/designer/shared/store/selectors/node.selectors'

import { NodeActionsState, nodeActionsFeatureKey } from '../reducers/node-actions.reducer'

export const selectFeature = createFeatureSelector<NodeActionsState>(nodeActionsFeatureKey)

export const selectedNodeActions = createSelector(
  selectFeature,
  selectedNode,
  (state: NodeActionsState, _selectedNode) =>
    state?.[_selectedNode?.id] ? state[_selectedNode.id] : null
)

export const startSubprocessActions = createSelector(
  selectedNodeActions,
  (actions: ActionDefinition[]) =>
    actions?.filter((action) => action.handlerService === ActionHandler.START_SUB_PROCESS)
)

export const selectedAction = (selectedNodeId: number) =>
  createSelector(selectFeature, (state: NodeActionsState) =>
    state[selectedNodeId]?.find((action) => action.id === state.selected)
  )

export const selectedNodeUiActions = createSelector(selectedNodeActions, (selectedNodeActions) =>
  selectedNodeActions
    ? selectedNodeActions
        .filter(
          (action) =>
            AllowedActionTypesForUIActions.includes(action.handlerService) &&
            !action.parentFlowxUuid &&
            action.manual
        )
        .map((action) => ({
          label: action.name,
          value: action.flowxUuid,
          repeatable: action.repeatable,
          handlerService: action.handlerService,
          optional: action.optional,
          nodeDefinitionId: action.nodeDefinitionId,
        }))
    : null
)

export const selectCurrentAction = createSelector(
  selectFeature,
  selectedNodeActions,
  (state: NodeActionsState, actions: ActionDefinition[]) =>
    actions?.find((action) => action.id === state.selected)
)

export const allNodeActions = createSelector(selectFeature, (state: NodeActionsState) => {
  const allActions = Object.values(state)
    .filter(Array.isArray)
    .flat()
    .filter((action): action is ActionDefinition => action !== null && action !== undefined)
  return allActions
})

export const nodeActionsById = (nodeId: string | number) =>
  createSelector(selectFeature, (state: NodeActionsState) => (state[nodeId] ? state[nodeId] : null))
